// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_kc-0";